module.exports = __webpack_public_path__ + "img/river-rock-walk.e1ce2ed7.webp";